import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';

export interface SetEnabledLinkedTaskStatusForSchedulesParams extends IMultipleIdsParams {
  readonly enabled: boolean;
}

export class SetEnabledLinkedTaskStatusForSchedulesRequest extends Request<SetEnabledLinkedTaskStatusForSchedulesParams, IResult> {
  constructor(ids: string[], enabled: boolean) {
    super('setEnabledLinkedTaskStatusForSchedules', { ids: ids, enabled: enabled });
  }
}
